module.exports = __webpack_public_path__ + "img/zykjyr-banner.779c5806.jpg";